var React = require('react');

function UpworkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 9C0.4 9 0 9.4 0 10L0 24.1C0 30.3 4.7 35.6 10.8 36 16.7 36.3 21.7 32.2 22.8 26.7 23.4 27.4 23.9 28.1 24.5 28.8L21 43.8C20.9 44.1 21 44.4 21.2 44.6 21.4 44.9 21.7 45 22 45L27.1 45C27.6 45 28 44.7 28.1 44.2 28.7 41.6 29.7 37.5 30.5 33.8L31.5 34.3C33.6 35.4 35.8 36 38 36 45.2 36 50.9 29.6 49.9 22.3 49.2 17.4 45.4 13.3 40.6 12.3 35 11.1 29.5 13.9 27.2 18.7 27.2 18.7 26.9 19.3 26.7 19.9 25.1 17 24.1 14.1 23.6 12 23.4 11.2 23.1 9.8 23.1 9.7 23 9.3 22.6 9 22.2 9L17 9C16.4 9 16 9.4 16 10L16 24.3C16 26.6 14.3 28.8 11.9 29 9.3 29.2 7 27.1 7 24.5L7 10C7 9.4 6.6 9 6 9L1 9zM38 19C40.8 19 43 21.2 43 24 43 26.8 40.8 29 38 29 35.8 29 33.7 27.7 32.3 26.5 32.8 24.3 33.2 22.8 33.2 22.7 33.7 20.5 35.7 19 38 19z"}));
}

UpworkInline.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = UpworkInline;

UpworkInline.default = UpworkInline;
